var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.5A.5.5 0 014 4v5h5V6.438c0-.416.214-.556.462-.331l3.351 2.96a.527.527 0 010 .806l-3.35 2.97c-.261.215-.463.073-.463-.341V10H3.5a.5.5 0 01-.5-.5V4a.5.5 0 01.5-.5z",
    fill: "#A8A8A8"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjUgMy41QzMuNzc2MTQgMy41IDQgMy43MjM4NiA0IDRMNCA5SDlMOSA2LjQzNzg4QzkgNi4wMjE2NCA5LjIxMzY1IDUuODgyMDQgOS40NjIyMSA2LjEwNjc2TDEyLjgxMzQgOS4wNjcyOUMxMi44NzE5IDkuMTE2ODMgMTIuOTE4OSA5LjE3ODUxIDEyLjk1MTEgOS4yNDgwNEMxMi45ODMzIDkuMzE3NTcgMTMgOS4zOTMyOCAxMyA5LjQ2OTkxQzEzIDkuNTQ2NTQgMTIuOTgzMyA5LjYyMjI1IDEyLjk1MTEgOS42OTE3OEMxMi45MTg5IDkuNzYxMzEgMTIuODcxOSA5LjgyMjk5IDEyLjgxMzQgOS44NzI1NEw5LjQ2MjIxIDEyLjg0MjRDOS4yMDE3NCAxMy4wNTc4IDkgMTIuOTE2NSA5IDEyLjUwMTlWMTBIMy41QzMuMjIzODYgMTAgMyA5Ljc3NjE0IDMgOS41VjRDMyAzLjcyMzg2IDMuMjIzODYgMy41IDMuNSAzLjVaIiBmaWxsPSIjQThBOEE4Ii8+Cjwvc3ZnPgo=";
export { SvgSubmenuArrow as ReactComponent };